import { Component, OnInit, Input } from '@angular/core';
import { Settings } from '../../model/settings.model';
import { ToastService } from '../../service/toast.service';
import { ParametersService } from '../../service/parameters.service';
import { FormGroup, FormControl } from '@angular/forms';
import { settings } from 'cluster';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Component({
  selector: 'app-parameters-company',
  templateUrl: './parameters-company.component.html',
  styleUrls: ['./parameters-company.component.less']
})
export class ParametersCompanyComponent implements OnInit {
  @Input() settings: Settings;
  @Input() company: boolean;
  timerEvent: NodeJS.Timer;
  form: FormGroup;
  logoButton: String;
  stampButton: String;

  constructor(private readonly _parametersService: ParametersService,
    private readonly i18n: I18n,
    private readonly _toastService: ToastService) {
    this.form = new FormGroup({
      name: new FormControl(''),
      address: new FormControl(''),
      phone: new FormControl(''),
      mail: new FormControl(''),
      site: new FormControl(''),
      other: new FormControl(''),
      footer: new FormControl(''),
    });
  }

  handleFileInputStamp(fileList : FileList){
    console.log("handleFileInputStamp");
    if (fileList.length !== 1){
      this.stampButton =  this.i18n({
        id: "error",
        value: "Erreur",
        description: "Erreur",
        meaning: "parameters_company"
      })
      return;
    }
    if (fileList.item(0).type !== "image/png")
    {
      this.stampButton =  this.i18n({
        id: "pictureError",
        value: "Erreur : veuillez insérer un PNG",
        description: "Erreur : veuillez insérer un PNG",
        meaning: "parameters_company"
      })
      return;
    }
    this.stampButton = this.i18n({
      id: "onCharge",
      value: "Chargement...",
      description: "Chargement...",
      meaning: "parameters_company"
    });
    this._toastService.toastOpen(true);
    this._parametersService.saveCompanyStamp(fileList.item(0), this.company)
    .then((saved) => {
      this.settings.companyLogo = saved.companyLogo;
      this.stampButton = this.settings.companyStamp.name().slice(33);
      this._toastService.toastOpen(false);
    }).catch( (error) => {this.stampButton = "Erreur"})
  }


  handleFileInputLogo(fileList : FileList){
    console.log("handleFileInputLogo");
    if (fileList.length !== 1){
      this.logoButton =  this.i18n({
        id: "error",
        value: "Erreur",
        description: "Erreur",
        meaning: "parameters_company"
      })
      return;
    }
    if (fileList.item(0).type !== "image/png")
    {
      this.logoButton =  this.i18n({
        id: "pictureError",
        value: "Erreur : veuillez insérer un PNG",
        description: "Erreur : veuillez insérer un PNG",
        meaning: "parameters_company"
      })
      return;
    }
    this.logoButton = this.i18n({
      id: "onCharge",
      value: "Chargement...",
      description: "Chargement...",
      meaning: "parameters_company"
    });
    this._toastService.toastOpen(true);
    this._parametersService.saveCompanyLogo(fileList.item(0), this.company)
    .then((saved) => {
      this.settings.companyLogo = saved.companyLogo;
      this.logoButton = this.settings.companyLogo.name().slice(33);
      this._toastService.toastOpen(false);
    }).catch( (error) => {this.logoButton = "Erreur"})
  }

  ngOnInit() {
    document.getElementById('get_logo').onclick = function () {
      document.getElementById('my_logo').click();
    };

    document.getElementById('get_stamp').onclick = function () {
      document.getElementById('my_stamp').click();
    };

    if (this.settings.companyLogo) {
      this.logoButton = this.settings.companyLogo.name().slice(33);
    } else {
      this.logoButton = this.i18n({
        id: "logoChoice",
        value: "Choisir un logo.",
        description: "Choisir un logo.",
        meaning: "parameters_company"
      });
    }

    if (this.settings.companyStamp) {
      this.stampButton = this.settings.companyStamp.name().slice(33);
    } else {
      this.stampButton = this.i18n({
        id: "stampChoice ",
        value: "Choisir un tampon.",
        description: "Choisir un tampon.",
        meaning: "parameters_company"
      });
    }

    this.form.setValue({
      name: this.settings.company.name || '',
      address: this.settings.company.address || '',
      phone: this.settings.company.phone || '',
      mail: this.settings.company.mail || '',
      site: this.settings.company.site || '',
      other: this.settings.company.other || '',
      footer: this.settings.company.footer || '',
    });
    this.form.valueChanges.subscribe(newValues => {
      console.log("newValues", newValues)
      this.settings.company.name = newValues.name
      this.settings.company.address = newValues.address
      this.settings.company.phone = newValues.phone
      this.settings.company.mail = newValues.mail
      this.settings.company.site = newValues.site
      this.settings.company.other = newValues.other
      this.settings.company.footer = newValues.footer
      this.sendData();
    });
  }


  sendData() {
    clearTimeout(this.timerEvent);
    this.timerEvent = setTimeout(() => {
      this._toastService.toastOpen(true);
      this._parametersService.saveCompany(this.settings.company, this.company).then((saved: Settings) => {
        this.settings.company = saved.company;
        this._toastService.toastOpen(false);
      });
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./src/app/element/parameters-company/parameters-company.component.ts